import React, { useEffect, useMemo, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Box,
  TextField,
  CssBaseline,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { toggleDrawer } from "../../redux/actions/toggleActions";
import { useNavigate, Outlet } from "react-router-dom";
import { FaCog, FaComment, FaPoll, FaStar, FaUserCircle } from "react-icons/fa";
import { Drawer, drawerWidthOpen, drawerWidthCollapsed } from "../UI/reusable-components/Drawer";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  SIGN_OUT_SUCCESS,
  SIGN_IN_SUCCESS,
} from "../../redux/actions/actionTypes";
import { getMarketPlaces } from "../../redux/actions/marketplacesActions";
import { getEcommercePlaces } from "../../redux/actions/ecommercePlaceActions";
import NotificationsIcon from "@mui/icons-material/Notifications";
import notificationService from "../../services/notificationService";
import NotificationDropdown from "../UI/reusable-components/NotificationComponents/NotificationDropdown";
import authService from "../../services/authService";
import { toast } from "react-hot-toast";
import { setSelectedStore } from "../../redux/actions/storeActions";
import FeedbackModal from "../UI/reusable-components/userFeedbackComponents/feedbackModal";
import userFeedbackService from "../../services/userFeedbackService";
import { MdSyncAlt } from "react-icons/md";
import { FiTruck, FiUploadCloud } from "react-icons/fi";
import { APP_CONFIG } from "../../config/appConfig";
import SchoolIcon from "@mui/icons-material/School";
import TrainingTourModal from "../UI/reusable-components/TrainingTourModal";
import { trainingTourSteps } from "../../config/trainingTourSteps";
// Ortak ikon stilleri
const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  minWidth: 40,
  fontSize: "1.2rem",
  color: "#696B6C",
  "&:hover": {
    color: "black",
  },
}));

const AppBarStyled = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "#FFFFFF",
  color: "#424242",
  borderBottom: "2px solid #E3F2FD",
  boxShadow: "0 2px 8px rgba(13, 71, 161, 0.08)",
}));

const Footer = styled("footer")(({ theme }) => ({
  flexShrink: 0,
  padding: theme.spacing(2),
  textAlign: "center",
  backgroundColor: "#FAFAFA",
  color: "#424242",
  width: "100%",
  borderTop: "1px solid #E0E0E0",
}));

const SearchField = styled(TextField)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "4px",
  marginRight: theme.spacing(2),
  "& .MuiOutlinedInput-root": {
    height: "40px",
    "& fieldset": {
      borderColor: theme.palette.grey[400],
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const MasterPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [notification, setNotification] = useState([]);
  const [userFeedback, setUserFeedback] = useState([]);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [isTrainingOpen, setIsTrainingOpen] = useState(false);
  const [trainingStepIndex, setTrainingStepIndex] = useState(0);

  // Redux'tan user bilgisini al
  const user = useSelector((state) => state?.auth?.user);
  const commonStores = user?.commonStores || [];

  const userDataStr = localStorage.getItem("userData");
  const userData = userDataStr ? JSON.parse(userDataStr) : null;

  const currentStoreId =
    userData?.storeId ||
    commonStores.find((store) => store.active === true)?.id ||
    "";
  const [selectedStore, setSelectedStore] = useState(currentStoreId);

  const handleDrawerToggle = () => {
    setDrawerOpen((prev) => !prev);
    dispatch(toggleDrawer());
  };

  const handleItemClick = (path) => {
    navigate(path);
    // setDrawerOpen(false);
  };

  const handleProfileClick = () => {
    navigate("/Profile");
  };

  const logOut = () => {
    dispatch({ type: SIGN_OUT_SUCCESS });
    localStorage.removeItem("userData");
    navigate("/auth");
  };

  const userId = useSelector((state) => state?.auth?.user?.id);
  const getNotification = async () => {
    try {
      var response = await notificationService.fetchNotification(userId);
      setNotification(response?.data);
    } catch (exx) {}
  };

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const sideNavWidth = isDesktop
    ? drawerOpen
      ? drawerWidthOpen
      : drawerWidthCollapsed
    : 0;

  useEffect(() => {
    getNotification();
    const handleResize = () => {};
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Eğer localStorage'da mağaza adı yoksa ve commonStores'da mağaza varsa, ilk mağazayı kaydet
    if (
      !localStorage.getItem("selectedStoreName") &&
      commonStores &&
      commonStores.length > 0
    ) {
      localStorage.setItem("selectedStoreName", commonStores[0].storeName);
    }
  }, [commonStores]);

  const handleStoreChange = async (event) => {
    try {
      const selectedStoreId = event.target.value;
      setSelectedStore(selectedStoreId);

      // Seçilen store'un bilgilerini bul
      const selectedStoreData = commonStores.find(
        (store) => store.id === selectedStoreId
      );

      if (selectedStoreData) {
        // Store name'i Redux'a kaydet
        dispatch({
          type: "STORE_SELECTED",
          payload: selectedStoreData.storeName,
        });

        // Quick login isteği yap
        const response = await authService.quickLogin(
          selectedStoreData.storeName
        );

        if (response.data.success) {
          if (response.data.data) {
            response.data.data.storeId = selectedStoreId;
            response.data.data.storeName = selectedStoreData.storeName;
          }

          // Redux store'u güncelle
          dispatch({
            type: SIGN_IN_SUCCESS,
            payload: response.data,
          });

          // LocalStorage'i güncelle
          localStorage.setItem("userData", JSON.stringify(response.data.data));

          toast.success("Store başarıyla değiştirildi");

          // Sayfayı yenile
          window.location.reload();

          localStorage.setItem(
            "selectedStoreName",
            selectedStoreData.storeName
          );
        } else {
          toast.error("Store değiştirilemedi");
        }
      }
    } catch (error) {
      console.error("Store değiştirme hatası:", error);
      toast.error("Store değiştirme sırasında bir hata oluştu");
      setSelectedStore(""); // Seçimi sıfırla
    }
  };
  const getUserFeedback = async () => {
    try {
      const response = await userFeedbackService.fetchUserFeedback({
        userId: userId,
      });
      setUserFeedback(response.data);
      console.log("Kullanıcı geri bildirimleri:", response);
    } catch (error) {
      console.error("Kullanıcı geri bildirim alma hatası:", error);
    }
  };
  useEffect(() => {
    getUserFeedback();
  }, [userId]);

  const currentTrainingStep = useMemo(
    () => trainingTourSteps[trainingStepIndex] || null,
    [trainingStepIndex]
  );
  const currentTrainingRoute = isTrainingOpen ? currentTrainingStep?.route : null;
  const isTransferTrainingTarget = currentTrainingRoute === "/ProductTransfers";
  const isProfileTrainingTarget = currentTrainingRoute === "/profile";

  const startTraining = () => {
    setTrainingStepIndex(0);
    setIsTrainingOpen(true);
  };

  const closeTraining = () => {
    setIsTrainingOpen(false);
  };

  const nextTrainingStep = () => {
    if (!drawerOpen) {
      setDrawerOpen(true);
    }
    setTrainingStepIndex((prev) =>
      prev < trainingTourSteps.length - 1 ? prev + 1 : prev
    );
  };

  const previousTrainingStep = () => {
    setTrainingStepIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const finishTraining = () => {
    setIsTrainingOpen(false);
    setTrainingStepIndex(0);
  };

  useEffect(() => {
    if (!isTrainingOpen) {
      return;
    }

    const step = trainingTourSteps[trainingStepIndex];
    if (step?.route) {
      navigate(step.route);
    }
  }, [isTrainingOpen, trainingStepIndex, navigate]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <CssBaseline />
      <AppBarStyled position="fixed">
        <Toolbar>
          <IconButtonStyled
            edge="start"
            color="inherit"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButtonStyled>
          <img
            src={APP_CONFIG.logoUrl}
            alt="Logo"
            style={{ height: "60px", marginRight: "10px" }}
          />
          <div style={{ flexGrow: 1 }} />
          <Typography
            variant="body1"
            sx={{
              backgroundColor: "transparent",
              padding: {
                xs: "6px 12px",
                sm: "8px 16px",
              },
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              marginRight: {
                xs: 1,
                sm: 2,
              },
              border: "1px solid #e2e8f0",
              color: "#334155",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              fontSize: {
                xs: "0.75rem", 
                sm: "0.875rem", 
                md: "1rem",
              },
              "&:hover": {
                backgroundColor: "#f8fafc",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                borderColor: "#cbd5e1",
              },
              ...(isTransferTrainingTarget && {
                backgroundColor: "#fffbeb",
                borderColor: "#f59e0b",
                color: "#92400e",
                boxShadow: "0 0 0 1px #fed7aa inset",
              }),
            }}
            onClick={() => navigate("/ProductTransfers")}
          >
            <FiUploadCloud
              style={{
                marginRight:8,
                color: "#6366f1",
                strokeWidth: 1.5,
                fontSize: {
                  xs: "1rem",
                  sm: "1.25rem",
                  md: "1.5rem",
                },
              }}
            />
            <Box
              sx={{
                display: {
                  xs: "none",
                  sm: "block",
                },
              }}
            >
              Ürün Transfer Durumu
            </Box>
            <Box
              sx={{
                display: {
                  xs: "block",
                  sm: "none",
                },
              }}
            >
              Transfer
            </Box>
            {isTransferTrainingTarget && (
              <Box
                sx={{
                  ml: 1,
                  px: 1,
                  py: 0.2,
                  borderRadius: "8px",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  backgroundColor: "#fff7ed",
                  border: "1px solid #fdba74",
                  color: "#9a3412",
                }}
              >
                Bu sayfa burada
              </Box>
            )}
          </Typography>
          <Button
            variant="outlined"
            startIcon={<SchoolIcon />}
            onClick={startTraining}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              minWidth: { xs: "auto", sm: 130 },
              mr: { xs: 1, sm: 2 },
              px: { xs: 1, sm: 1.5 },
              whiteSpace: "nowrap",
            }}
          >
            Eğitim
          </Button>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#FFFFFF",
              borderRadius: 2,
              height: "40px",
              border: "1px solid #BBDEFB",
              "&:hover": {
                borderColor: "#1565C0",
                boxShadow: "0 2px 4px rgba(13, 71, 161, 0.1)",
              },
            }}
          >
            <IconButtonStyled
              color="inherit"
              onClick={handleProfileClick}
              sx={{
                height: "32px",
                width: "32px",
                padding: "4px",
                ...(isProfileTrainingTarget && {
                  backgroundColor: "#fffbeb",
                  border: "1px solid #f59e0b",
                  color: "#9a3412",
                }),
              }}
            >
              <FaUserCircle />
            </IconButtonStyled>
            {isProfileTrainingTarget && (
              <Box
                sx={{
                  mr: 1,
                  px: 0.8,
                  py: 0.2,
                  borderRadius: "8px",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  backgroundColor: "#fff7ed",
                  border: "1px solid #fdba74",
                  color: "#9a3412",
                  whiteSpace: "nowrap",
                  display: { xs: "none", sm: "block" },
                }}
              >
                Bu sayfa burada
              </Box>
            )}
            {commonStores && commonStores.length > 0 && (
              <FormControl sx={{ minWidth: 120 }}>
                <Select
                  value={selectedStore}
                  onChange={handleStoreChange}
                  size="small"
                  renderValue={(selected) => {
                    const selectedStoreData = commonStores.find(
                      (store) => store.id === selected
                    );
                    return selectedStoreData
                      ? selectedStoreData.storeName
                      : "Mağaza Seçin";
                  }}
                  sx={{
                    height: "32px",
                    backgroundColor: "transparent",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                >
                  {selectedStore === "" && (
                    <MenuItem value="" disabled>
                      <em>Mağaza Seçin</em>
                    </MenuItem>
                  )}
                  {commonStores.map((store) => (
                    <MenuItem key={store.id} value={store.id}>
                      {store.storeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Box>
          <NotificationDropdown
            notifications={notification}
            getNotification={getNotification}
          />
          <IconButtonStyled color="inherit" onClick={logOut}>
            <LogoutIcon />
          </IconButtonStyled>
        </Toolbar>
      </AppBarStyled>
      {/* Drawer */}
      <Drawer
        drawerOpen={drawerOpen}
        handleDrawerToggle={handleDrawerToggle}
        handleItemClick={handleItemClick}
        trainingTargetPath={
          isTrainingOpen && trainingTourSteps[trainingStepIndex]
            ? trainingTourSteps[trainingStepIndex]?.route
            : null
        }
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          ml: `${sideNavWidth}px`,
          width: sideNavWidth ? `calc(100% - ${sideNavWidth}px)` : "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          p: { xs: 2, sm: 3 },
          pt: { xs: 9, sm: 10 },
          pb: 3,
          bgcolor: "#FAFAFA",
          overflowX: "hidden",
          overflowY: "auto",
          transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Container maxWidth={false} disableGutters sx={{ width: "100%", minWidth: 0 }}>
          <Box sx={{ width: "100%", minWidth: 0 }}>
            <Outlet />
          </Box>
        </Container>
      </Box>
      {userFeedback.length === 0 && (
        <IconButton
          sx={{
            position: "fixed",
            bottom: "30px",
            right: "25px",
            backgroundColor: "#424242",
            color: "white",
            "&:hover": {
              backgroundColor: "#212121",
            },
            zIndex: 10000,
            width: "60px",
            height: "60px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            borderRadius: "50%",
          }}
          onClick={() => setFeedbackModal(true)}
        >
          <FaStar />
        </IconButton>
      )}

      <Footer>
        <Typography variant="body2">
          &copy; {new Date().getFullYear()} {APP_CONFIG.nameNoSpace} Tüm Hakları
          Saklıdır.
        </Typography>
      </Footer>
      <FeedbackModal
        isOpen={feedbackModal}
        onClose={() => setFeedbackModal(false)}
        getUserFeedback={getUserFeedback}
      />
      <TrainingTourModal
        open={isTrainingOpen}
        step={currentTrainingStep}
        stepIndex={trainingStepIndex}
        totalSteps={trainingTourSteps.length}
        onClose={closeTraining}
        onNext={nextTrainingStep}
        onPrevious={previousTrainingStep}
        onFinish={finishTraining}
      />
    </Box>
  );
};

export default MasterPage;
